// Inventory stock is authoritative; never count the unique ownership ID as another unit.
export function tradeableQuantity(player,itemId){
 const inventory=player?.inventory;
 if(!inventory||!Object.hasOwn(inventory,itemId))return 0;
 const stock=inventory[itemId];
 if(!Number.isSafeInteger(stock)||stock<=0||itemId.startsWith('bound-ghost-')||itemId==='starter-pet-box'||itemId===player.journey?.keepsake||Object.values(player.profile?.equipment??{}).includes(itemId))return 0;
 return Math.max(0,stock-(itemId==='bamboo-knife'?1:0));
}
